/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FullVisitViewModel } from './FullVisitViewModel'; 

export function getFullVisitOptions(visitId: string, onSuccess?: (result: FullVisitViewModel) => void) {
	return queryOptions({
		queryKey: ['full-visit', visitId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/visits/queries/getvisitdata/getfullvisit/' + visitId;
			const resp = await axios.get<FullVisitViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(visitId)
	});
}